/* Begin Baby Care Forest Journey — two approved paintings, reversible scroll blend. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value) => Math.max(0, Math.min(1, value));
  const smooth = (value) => { const t = clamp(value); return t * t * (3 - 2 * t); };

  document.querySelectorAll('[data-bbc-forest-journey]').forEach((journey) => {
    if (journey.dataset.forestInitialized === 'true') return;
    journey.dataset.forestInitialized = 'true';

    const track = journey.querySelector('[data-forest-track]');
    const stage = journey.querySelector('[data-forest-stage]');
    const next = journey.querySelector('[data-forest-next]');
    const gameLink = journey.querySelector('[data-forest-game-link]');
    const images = Array.from(stage?.querySelectorAll('[data-forest-image]') || []);
    if (!track || !stage || !gameLink || images.length !== 3) return;

    document.body.classList.add('bbc-forest-home');
    let raf = 0;
    let progress = 0;

    function measure() {
      const span = Math.max(1, track.offsetHeight - stage.offsetHeight);
      progress = clamp(-track.getBoundingClientRect().top / span);
      return progress;
    }

    function updateHeader() {
      document.body.classList.toggle('bbc-forest-past', journey.getBoundingClientRect().bottom <= 2);
    }

    function render() {
      raf = 0;
      if (!journey.isConnected) return;
      updateHeader();
      if (journey.dataset.motion !== 'ready') return;

      const t = measure();
      // Paint 1 clears before Paint 2 typography arrives. No wipes or limb animation.
      const clear = smooth((t - 0.06) / 0.25);
      const dash = smooth((t - 0.54) / 0.40);
      journey.style.setProperty('--forest-clear', clear.toFixed(4));
      journey.style.setProperty('--forest-dash', dash.toFixed(4));

      const ready = dash >= .86;
      gameLink.tabIndex = ready ? 0 : -1;
      gameLink.setAttribute('aria-hidden', ready ? 'false' : 'true');
      next?.setAttribute('aria-label', t >= .94 ? 'Continue to the homepage' : 'Scroll to Diaper Dash');
    }

    function schedule() {
      if (!raf) raf = requestAnimationFrame(render);
    }

    function synchronize() {
      journey.dataset.motion = reducedMotion.matches ? 'static' : 'ready';
      if (reducedMotion.matches) {
        gameLink.tabIndex = -1;
        gameLink.setAttribute('aria-hidden', 'true');
      }
      schedule();
    }

    next?.addEventListener('click', (event) => {
      event.preventDefault();
      const journeyTop = window.scrollY + journey.getBoundingClientRect().top;
      const span = Math.max(0, track.offsetHeight - stage.offsetHeight);
      const t = measure();
      const target = t < .94 ? journeyTop + span : journeyTop + journey.offsetHeight;
      window.scrollTo({ top: Math.round(target), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    reducedMotion.addEventListener?.('change', synchronize);

    updateHeader();
    if (reducedMotion.matches) {
      synchronize();
    } else {
      Promise.all(images.map((img) => img.decode()))
        .then(synchronize)
        .catch(() => {
          journey.dataset.motion = 'static';
          updateHeader();
        });
    }
  });
})();
